import { Injectable } from '@angular/core';
import { StorageWorker } from './storage-worker';

@Injectable()
export class WebStorageService {
  public local: StorageWorker;
  public session: StorageWorker;

  constructor() {
    this.local = new StorageWorker(window.localStorage);
    this.session = new StorageWorker(window.sessionStorage);
  }

  public getMostPersistentStorage(): StorageWorker {
    return this.local.isAvailable ? this.local
      : this.session;
  }
}
